import Vue from 'vue'
import title from './fragments/title'
import { formatDocument } from '@/util/document'
import { mailto, whatsApp, catalogDateWithoutTime } from '@/util/catalog'
import { rentOutTypes } from '@/components/appointment/formFieldsCreate/appointmentFormDefaults'

const area = 'dashboard.cardAppointment.'
const translate = (data) => Vue.i18n.translate(data)

const visitorContent = (data) => {
  const type = data?.type
  const visitor = data?.visitor

  if (!visitor || !type) return ''

  return `
    <details>
      ${title(rentOutTypes.includes(type) ? translate(area + 'tenant') : translate(area + 'visitor'))}
      <content>
        <h6 class="text-uppercase grey--text">
          ${translate(area + 'name')}
        </h6>
        <p class="body-2">${visitor.visitor_name}</p>

        <div class="row no-gutters">
          <div class="col mw-150">
            <h6 class="text-uppercase grey--text">
              ${translate(area + 'phone')}
            </h6>
            <p class="body-2 mb-3">
              ${whatsApp(visitor.visitor_phone)}
            </p>
          </div>
          <div class="col">
            <h6 class="text-uppercase grey--text">
              ${translate(area + 'user')}
            </h6>
            <p class="body-2 mb-3">
              ${mailto(visitor.visitor_mail)}
            </p>
          </div>
        </div>

        <div class="row no-gutters">
          ${visitor.visitor_document ? `
            <div class="col mw-150">
              <h6 class="text-uppercase grey--text">
                ${translate(area + 'cpf')}
              </h6>
              <p class="body-2 mb-3">
                ${formatDocument(visitor.visitor_document)}
              </p>
            </div>
          ` : ''}

          ${visitor.visitor_birth_date ? `
            <div class="col">
              <h6 class="text-uppercase grey--text">
                ${translate(area + 'birthDate')}
              </h6>
              <p class="body-2 mb-3">
                ${catalogDateWithoutTime(visitor.visitor_birth_date)}
              </p>
            </div>
          ` : ''}
        </div>
      </content>
    </details>
  `
}

export default visitorContent
